import { Box, Stack, Typography } from '@mui/material';
import StyledMiddleCard from './MiddleCard';
import styled from 'styled-components';

const StyledMiddleCardWithPadding = styled(StyledMiddleCard)(({ theme }) => ({
  padding: theme.spacing(8, 8.5),
}));

interface MiddleFormCardProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  width?: string;
}

const MiddleFormCard: React.FC<MiddleFormCardProps> = ({ title, subtitle, children, onSubmit, width }) => {

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSubmit(event);
  }

  return <StyledMiddleCardWithPadding sx={{ width: width }}>
    <Stack gap={8}>
      <Stack gap={0}>
        <Typography sx={{ paddingY: 0 }} variant="h5" fontWeight="bold">
          {title}
        </Typography>
        {subtitle && <Typography variant="body1" color="textSecondary">
          {subtitle}
        </Typography>}
      </Stack>
      <Box component="form" onSubmit={handleSubmit} sx={{ width: '100%' }}>
        {children}
        <button type="submit" style={{ display: 'none' }} />
      </Box>
    </Stack>
  </StyledMiddleCardWithPadding>;
}



export default MiddleFormCard;